import { render, staticRenderFns } from "./allocateOil.vue?vue&type=template&id=5dc162c2"
import script from "./allocateOil.vue?vue&type=script&lang=js"
export * from "./allocateOil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports